<template>
    <div>
        <div class="card card-custom">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">Active Engines</h3>
                </div>
            </div>
            <div class="card-body">
                <!-- NOTE - Hashtag engines -->
                <h3>Hashtag Engines</h3>
                <div>
                    <b-button
                        variant="light-success"
                        class="m-2"
                        target="_blank"
                        href="https://hashtastic.eu/engine/engine8.php"
                        >Engine 8</b-button
                    >
                    <b-button
                        variant="light-success"
                        class="m-2"
                        target="_blank"
                        href="https://hashtastic.eu/engine/engine.newhashtags2.php"
                        >Engine New Hashtags</b-button
                    >
                </div>

                <!-- NOTE - Account engines -->
                <h3>Account Engines</h3>
                <div>
                    <b-button
                        variant="light-success"
                        class="m-2"
                        target="_blank"
                        href="https://hashtastic.eu/engine/engine.accountscanner2.php"
                        >Account Scanner 2</b-button
                    >
                    <b-button
                        variant="light-success"
                        class="m-2"
                        target="_blank"
                        href="https://hashtastic.eu/engine/engine.accountids.php"
                        >Account IDs</b-button
                    >
                </div>

                <!-- NOTE - Campaign engines -->
                <h3>Campaign engines</h3>
                <div>
                    <b-button
                        variant="light-success"
                        class="m-2"
                        target="_blank"
                        href="https://hashtastic.eu/engine/engine.mycampaign.getposts.php"
                        >Get Posts</b-button
                    >
                    <b-button
                        variant="light-success"
                        class="m-2"
                        target="_blank"
                        href="https://hashtastic.eu/engine/engine.mycampaign.getranks2.php"
                        >Get Ranks 2</b-button
                    >
                </div>

                <!-- NOTE - Other engines -->
                <h3>Other engines</h3>
                <div>
                    <b-button
                        variant="light-success"
                        class="m-2"
                        target="_blank"
                        href="https://hashtastic.eu/engine/engine.viralmedia.php"
                        >Viral Media</b-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import { mapGetters } from "vuex";

export default {
    name: "EnginesPage",
    mixins: [],
    components: {},

    methods: {
        // First method here
        checkAdmin() {
            if (!this.isAdmin) {
                this.$router.push({
                    name: "dashboard",
                    params: {
                        propFlashMessages: [
                            {
                                type: "danger",
                                message: "You aren't authorized to access this area.",
                            },
                        ],
                    },
                });
            }
        },
    },

    mounted() {
        // Check if we're admin
        this.checkAdmin();

        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Engine Room", route: "admin" }]);
    },

    computed: {
        ...mapGetters({ currentUser: "auth/currentUser", isAdmin: "auth/isAdmin" }),
    },
};
</script>
